import IcoMoon from "../Layouts/IcoMooon";

const SocialMedias = ({ socialMediaList = [] }) => {
  return (
    <>
      {}
      <ul>
        {socialMediaList.map((item, i) => (
          <li key={i}>
            <a href={item?.url} target="_blank" rel="noreferrer">
              <IcoMoon icon={item?.["icon-svg-code"]} size={item?.size} />
            </a>
          </li>
        ))}
      </ul>
    </>
  );
};

export default SocialMedias;
